import React from 'react'
import { ListSubdivisions } from '~/features/common/Taxipark/Subdivisions/ListSubdivisions'
import { Container } from '~/shared/ui/Layout'

export const ListSubdivisionsPage = () => {
  return (
    <Container>
      <ListSubdivisions />
    </Container>
  )
}
